import React from 'react';
import PropTypes from 'prop-types';

import './Password.css';

class Password extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }
  
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  onToggleDisplay(e) {
    e.preventDefault();

    this.setState({ show: !this.state.show });
  }

  render() {
    const { show } = this.state;
    const { value, name, onChange, type, ...rest } = this.props;

    const inputType = show ? 'text' : 'password';
    const buttonClass = show ? 'ion-eye-disabled' : 'ion-eye';

    return (
      <div className='password-container'>
        <div className='password-left'>
          <input value={value} type={inputType} name={name} onChange={onChange} {...rest} />
        </div>
        <div className='password-right'>
          <button onClick={(e) => this.onToggleDisplay(e)}><i className={buttonClass} aria-hidden="true"></i></button>
        </div>
      </div>
    );
  }
};

export default Password;



// WEBPACK FOOTER //
// ./src/components/Password/Password.jsx